import { Navigate } from 'react-router-dom';

import { useAWAStore } from '@/stores/awa.store';

function AWARootRedirect() {
  const { workspace } = useAWAStore();

  if (!workspace) {
    return <></>;
  }

  return <Navigate to={`/${workspace.id}`} replace />;
}

export default AWARootRedirect;
